import { useState, useEffect } from 'react';
import projectsService from '../services/projectsService';
import { User } from '../types';

export const useUsers = () => {
  const [users, setUsers] = useState<User[]>([]);

  const loadUsers = async () => {
    try {
      const data = await projectsService.getUsers();
      setUsers(data);
    } catch (err) {
      console.error('Error loading users:', err);
    }
  };

  useEffect(() => {
    loadUsers();
  }, []);

  return { users };
};